/*
 * @Author: cryi.liu
 * @Date: 2020-06-10 17:48:00
 * @LastEditTime: 2020-06-17 16:59:15
 * @Description: write you description
 */

import BaseService from './base.service';

export default class extends BaseService {
  // 考试题目信息
  async examQuestion(data = {}) {
    const url = this.API.answer.examQuestion;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  // 保存单个题目答案
  async saveAnswer(data = {}) {
    const url = this.API.answer.saveAnswer;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  // 完成的试卷题目及答案
  async paper(data = {}) {
    const url = this.API.answer.paper;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  // 提交试卷
  async submitPaper(data = {}) {
    const url = this.API.answer.submitPaper;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  // 保存考生考试剩余时间
  async saveRemaining(data = {}) {
    const url = this.API.answer.saveRemaining;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {object} params
   * @func 阅卷题目列表
   */
  async markQuestionList(params = {}) {
    const url = this.API.answer.markQuestionList;
    const result = await this.formPostOfQuery(url, params);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {object} data
   * @func 考生答题信息列表
   */
  async markUserList(data = {}) {
    const url = this.API.answer.markUserList;
    const result = await this.jsonPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {object} data
   * @func 考生答题分数保存
   */
  async markSaveScore(data = {}) {
    const url = this.API.answer.markSaveScore;
    const result = await this.jsonPostOfBody(url, data);
    return result;
  }
}
